import { Flex, Flyout } from '@auviknetworks/iceberg-ui';
import {
    ClickableCell,
    NumberCell,
    StringCell
} from 'application/Shared/Components/Cells';
import {
    ManagedTableV2ContextProvider,
    ManagedTableV2UI
} from 'application/Shared/Components/Table';
import { Header } from 'application/Shared/Components/Table/Header';
import { ColumnDef } from 'application/Shared/Components/Table/types';
import { Z_INDEX } from 'application/Shared/Constants';
import React from 'react';

export type LicenseCardData = {
    id: string;
    label: string;
    value: number;
    onClick: () => void;
};

const columns: ColumnDef<LicenseCardData, string>[] = [
    {
        accessorKey: 'label',
        cell: (props) => <ClickableCell {...props} component={StringCell} />,
        enableColumnFilter: false,
        enableHiding: false,
        header: Header,
        id: 'label',
        name: 'Common.label',
        size: 300,
        testId: 'accounts'
    },
    {
        accessorKey: 'value',
        cell: (props) => <ClickableCell {...props} component={NumberCell} />,
        enableColumnFilter: false,
        enableHiding: false,
        header: Header,
        id: 'value',
        name: 'Common.value',
        size: 300,
        testId: 'value'
    }
];

export interface LicenseTypesFlyoutMenuProps {
    /** The data to display in the flyout menu. */
    data: LicenseCardData[];
    /** The function to call when the flyout menu is closed. */
    onClose: () => void;
    /** The title of the flyout menu. */
    title: string;
}

export const LicenseTypesFlyoutMenu = ({
    data,
    onClose,
    title
}: LicenseTypesFlyoutMenuProps) => (
    <Flyout title={title} onClose={onClose} zIndex={Z_INDEX.FLYOUT_HIGH}>
        <Flex width="100%">
            <ManagedTableV2ContextProvider
                columns={columns}
                ignoreSearchParams
                mode="client"
                rows={data}
                rowsPerPage={10}
                searchEnabled
                sortDirection="DESC"
                sortKey="value"
            >
                <ManagedTableV2UI renderFooter />
            </ManagedTableV2ContextProvider>
        </Flex>
    </Flyout>
);
